import React from "react";
import { FaPlus } from "react-icons/fa";

/** Floating action button (bottom-right), used for "add new" across screens. */
const Fab = ({ onClick, label = "Προσθήκη", icon: Icon = FaPlus }) => (
  <button
    onClick={onClick}
    aria-label={label}
    className="fixed bottom-6 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full
               bg-brand-600 text-white ring-4 ring-white shadow-[0_6px_22px_rgba(0,0,0,0.35)]
               transition-all hover:bg-brand-700 active:scale-95"
    style={{ bottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}
  >
    <Icon size={22} />
  </button>
);

export default Fab;
